import { Avatar } from '../libs/avatar/avatar.interface'
import { FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'
import { FloApiSearchResponseData, SearchMeta, SearchQueryParams } from './search-data.service.interface'

export type CategoryAvatarData = Pick<Avatar, 'id' | 'primaryLabel' | 'image'> & {
  href: string
}

// Category filters. Add as needed. Spelling mattres!
export enum FacetFilter {
  GoverningBody = 'Governing Body',
  Conference = 'Conference',
  Gender = 'Gender',
  League = 'League'
}

export interface SearchResponseDataCategories {
  response: FloResponse<readonly FloApiSearchResponseData[], SearchMeta>
  queryParams?: SearchQueryParams
}
